import { CircleDot, ShieldCheck } from 'lucide-react';

import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';
import { cn } from '@apps/web/lib/utils';
import { type AdminAgentNoteVolatility } from '@libraries/typescript/api_client';

/**
 * Subtle volatility indicator. `stable` reads as "trust fully"; `volatile`
 * whispers "verify if load-bearing" without shouting the whole time.
 */
export function VolatilityGlyph({
    volatility,
    className,
}: {
    readonly volatility: AdminAgentNoteVolatility;
    readonly className?: string;
}) {
    if (volatility === 'stable') {
        return (
            <Tooltip>
                <TooltipTrigger asChild={true}>
                    <span
                        className={cn(
                            'inline-flex h-4 w-4 items-center justify-center text-emerald-600 dark:text-emerald-400',
                            className,
                        )}
                        aria-label="Stable"
                    >
                        <ShieldCheck
                            className="h-3.5 w-3.5"
                            aria-hidden="true"
                        />
                    </span>
                </TooltipTrigger>
                <TooltipContent side="top" className="text-xs">
                    Stable — trust fully.
                </TooltipContent>
            </Tooltip>
        );
    }
    return (
        <Tooltip>
            <TooltipTrigger asChild={true}>
                <span
                    className={cn(
                        'inline-flex h-4 w-4 items-center justify-center text-amber-600 dark:text-amber-400',
                        className,
                    )}
                    aria-label="Volatile"
                >
                    <CircleDot className="h-3 w-3" aria-hidden="true" />
                </span>
            </TooltipTrigger>
            <TooltipContent side="top" className="text-xs">
                Volatile — verify one evidence ref if load-bearing.
            </TooltipContent>
        </Tooltip>
    );
}
